import { ref, computed } from "vue";
import { defineStore } from "pinia";
import { isString } from "lodash-es";
const useAuthStore = defineStore(
  "auth",
  () => {
    const authData = ref(null);
    const token = computed(() => {
      var _a;
      return (_a = authData.value) == null ? void 0 : _a.token;
    });
    const contact = computed(() => {
      var _a;
      return (_a = authData.value) == null ? void 0 : _a.contact;
    });
    const contactId = computed(() => {
      var _a;
      return (_a = contact.value) == null ? void 0 : _a.id;
    });
    const contactName = computed(() => {
      var _a;
      return (_a = contact.value) == null ? void 0 : _a.name;
    });
    const setAuthData = (data) => {
      if (isString(data == null ? void 0 : data.contact)) {
        data.contact = JSON.parse(data.contact);
      }
      authData.value = data;
    };
    return {
      authData,
      token,
      contact,
      contactId,
      contactName,
      setAuthData
    };
  },
  {
    persist: true
  }
);
export {
  useAuthStore
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXV0aC5qcyIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3N0b3JlL2F1dGguanMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY29tcHV0ZWQsIHJlZiB9IGZyb20gXCJ2dWVcIjtcbmltcG9ydCB7IGRlZmluZVN0b3JlIH0gZnJvbSBcInBpbmlhXCI7XG5pbXBvcnQgeyBpc1N0cmluZyB9IGZyb20gXCJsb2Rhc2gtZXNcIjtcblxuZXhwb3J0IGNvbnN0IHVzZUF1dGhTdG9yZSA9IGRlZmluZVN0b3JlKFxuXHRcImF1dGhcIixcblx0KCkgPT4ge1xuXHRcdGNvbnN0IGF1dGhEYXRhID0gcmVmKG51bGwpO1xuXG5cdFx0Y29uc3QgdG9rZW4gPSBjb21wdXRlZCgoKSA9PiBhdXRoRGF0YS52YWx1ZT8udG9rZW4pO1xuXHRcdGNvbnN0IGNvbnRhY3QgPSBjb21wdXRlZCgoKSA9PiBhdXRoRGF0YS52YWx1ZT8uY29udGFjdCk7XG5cdFx0Y29uc3QgY29udGFjdElkID0gY29tcHV0ZWQoKCkgPT4gY29udGFjdC52YWx1ZT8uaWQpO1xuXHRcdGNvbnN0IGNvbnRhY3ROYW1lID0gY29tcHV0ZWQoKCkgPT4gY29udGFjdC52YWx1ZT8ubmFtZSk7XG5cblx0XHRjb25zdCBzZXRBdXRoRGF0YSA9IChkYXRhKSA9PiB7XG5cdFx0XHRpZiAoaXNTdHJpbmcoZGF0YT8uY29udGFjdCkpIHtcblx0XHRcdFx0ZGF0YS5jb250YWN0ID0gSlNPTi5wYXJzZShkYXRhLmNvbnRhY3QpO1xuXHRcdFx0fVxuXHRcdFx0YXV0aERhdGEudmFsdWUgPSBkYXRhO1xuXHRcdH07XG5cblx0XHRyZXR1cm4ge1xuXHRcdFx0YXV0aERhdGEsXG5cdFx0XHR0b2tlbixcblx0XHRcdGNvbnRhY3QsXG5cdFx0XHRjb250YWN0SWQsXG5cdFx0XHRjb250YWN0TmFtZSxcblx0XHRcdHNldEF1dGhEYXRhLFxuXHRcdH07XG5cdH0sXG5cdHtcblx0XHRwZXJzaXN0OiB0cnVlLFxuXHR9XG4pO1xuIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUlZLE1BQUMsZUFBZTtBQUFBLEVBQzNCO0FBQUEsRUFDQSxNQUFNO0FBQ0wsVUFBTSxXQUFXLElBQUksSUFBSTtBQUV6QixVQUFNLFFBQVEsU0FBUyxNQUFNOztBQUFBLDRCQUFTLFVBQVQsbUJBQWdCO0FBQUEsS0FBSztBQUNsRCxVQUFNLFVBQVUsU0FBUyxNQUFNOztBQUFBLDRCQUFTLFVBQVQsbUJBQWdCO0FBQUEsS0FBTztBQUN0RCxVQUFNLFlBQVksU0FBUyxNQUFNOztBQUFBLDJCQUFRLFVBQVIsbUJBQWU7QUFBQSxLQUFFO0FBQ2xELFVBQU0sY0FBYyxTQUFTLE1BQU07O0FBQUEsMkJBQVEsVUFBUixtQkFBZTtBQUFBLEtBQUk7QUFFdEQsVUFBTSxjQUFjLENBQUMsU0FBUztBQUM3QixVQUFJLFNBQVMsNkJBQU0sT0FBTyxHQUFHO0FBQzVCLGFBQUssVUFBVSxLQUFLLE1BQU0sS0FBSyxPQUFPO0FBQUEsTUFDMUM7QUFDRyxlQUFTLFFBQVE7QUFBQSxJQUNqQjtBQUVELFdBQU87QUFBQSxNQUNOO0FBQUEsTUFDQTtBQUFBLE1BQ0E7QUFBQSxNQUNBO0FBQUEsTUFDQTtBQUFBLE1BQ0E7QUFBQSxJQUNBO0FBQUEsRUFDRDtBQUFBLEVBQ0Q7QUFBQSxJQUNDLFNBQVM7QUFBQSxFQUNYO0FBQ0E7In0=
